export const SELECT_HINT_LEARN_MORE =
  'https://knowledge-base.yieldbird.com/prebid-stack/vendor-specific-prebid-modules'
